import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Oauth, OauthLoginParam, AccountOauthParam, OauthLoginResult, OauthExchangeParam, AccountOauthSWParam } from '../oauth.model';

export enum OauthActionTypes {
  GetOauths = '[Oauth] Get Oauth',
  LoadOauths = '[Oauth] Load Oauths',
  LoadOauthsFail = '[Oauth] Load Oauths Fail',
  AddAccountByOauth = '[Oauth] Add Account By Oauth',
  AddAccountOauth = '[Oauth] Add Account Oauth',
  DeleteAccountOauth = '[Oauth] Delete Account Oauth',
  UpdateAccountEmail = '[Oauth] Update Account Email',
  // UpsertAccountOauthSuccess = '[Oauth] Upsert Account Oauth Success',
  DeleteAccountOauthSuccess = '[Oauth] Delete Account Oauth Success',
  GetOauthLogin = '[Oauth] Get Oauth Login',
  OauthLogin = '[Oauth] Oauth Login',
  OauthLoginFail = '[Oauth] Oauth Login Fail',
  GetExchangeGoogleUserInfo = '[Oauth] Get Exchange Google UserInfo',
  GetFacebookAccessToken = '[Oauth] Get Facebook Access Token',
  GetExchangeFacebookUserInfo = '[Oauth] Get Exchange Facebook UserInfo',
  GetAccountOauthSWParam = '[Oauth] Get AccountOauthSW Param',
  AddAccountOauthSW = '[Oauth] Add AccountOauthSW',
}
export class GetOauths implements Action {
  readonly type = OauthActionTypes.GetOauths;

  constructor(public payload: any = null) {}
}

export class LoadOauths implements Action {
  readonly type = OauthActionTypes.LoadOauths;

  constructor(public payload: Oauth[]) {}
}

export class LoadOauthsFail implements Action {
  readonly type = OauthActionTypes.LoadOauthsFail;
}

export class AddAccountByOauth implements Action {
  readonly type = OauthActionTypes.AddAccountByOauth;

  constructor(public payload: AccountOauthParam) {}
}

export class AddAccountOauth implements Action {
  readonly type = OauthActionTypes.AddAccountOauth;

  constructor(public payload: AccountOauthParam) {}
}

export class DeleteAccountOauth implements Action {
  readonly type = OauthActionTypes.DeleteAccountOauth;

  constructor(public payload: AccountOauthParam) {}
}

export class UpdateAccountEmail implements Action {
  readonly type = OauthActionTypes.UpdateAccountEmail;

  constructor(public payload: AccountOauthParam) {}
}

// export class UpsertAccountOauthSuccess implements Action {
//   readonly type = OauthActionTypes.UpsertAccountOauthSuccess;

//   constructor(public payload: { Oauth: Oauth }) {}
// }

export class DeleteAccountOauthSuccess implements Action {
  readonly type = OauthActionTypes.DeleteAccountOauthSuccess;

  constructor(public payload: { id: number }) {}
}

export class GetOauthLogin implements Action {
  readonly type = OauthActionTypes.GetOauthLogin;

  constructor(public payload: OauthLoginParam) {}
}

export class OauthLogin implements Action {
  readonly type = OauthActionTypes.OauthLogin;

  constructor(public payload: any = []) {}
}

export class OauthLoginFail implements Action {
  readonly type = OauthActionTypes.OauthLoginFail;

  constructor(public payload: OauthLoginResult) {}
}

export class GetExchangeGoogleUserInfo implements Action {
  readonly type = OauthActionTypes.GetExchangeGoogleUserInfo;

  constructor(public payload: OauthExchangeParam) {}
}

export class GetFacebookAccessToken implements Action {
  readonly type = OauthActionTypes.GetFacebookAccessToken;

  constructor(public payload: OauthExchangeParam) {}
}

export class GetExchangeFacebookUserInfo implements Action {
  readonly type = OauthActionTypes.GetExchangeFacebookUserInfo;

  constructor(public payload: OauthExchangeParam) {}
}

export class GetAccountOauthSWParam implements Action {
  readonly type = OauthActionTypes.GetAccountOauthSWParam;

  constructor(public payload: AccountOauthSWParam) {}
}

export class AddAccountOauthSW implements Action {
  readonly type = OauthActionTypes.AddAccountOauthSW;

  constructor(public payload: AccountOauthSWParam) {}
}

export type OauthActions =
 GetOauths
 | LoadOauths
 | LoadOauthsFail
 | AddAccountByOauth
 | AddAccountOauth
 | DeleteAccountOauth
 | UpdateAccountEmail
//  | UpsertAccountOauthSuccess
 | DeleteAccountOauthSuccess
 | GetOauthLogin
 | OauthLogin
 | OauthLoginFail
 | GetExchangeGoogleUserInfo
 | GetFacebookAccessToken
 | GetExchangeFacebookUserInfo
 | GetAccountOauthSWParam
 | AddAccountOauthSW;
